import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么影迷选择51电影网观看未删减版
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center"
            >
              <span className="inline-flex w-14 h-14 items-center justify-center rounded-full bg-primary-500/10 text-primary-400 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base font-heading text-foreground-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}